import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.beforeCache = () => this.reset();
    document.addEventListener("turbo:before-cache", this.beforeCache);
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache);
    this.reset();
  }

  enter(event) {
    if (event.pointerType === "touch") return;
    this.hovered = true;
    this.update();
  }

  leave() {
    this.hovered = false;
    this.update();
  }

  focus() {
    this.focused = true;
    this.update();
  }

  blur() {
    this.focused = false;
    this.update();
  }

  reset() {
    this.hovered = false;
    this.focused = false;
    this.update();
  }

  update() {
    this.element.classList.toggle("technology--active", Boolean(this.hovered || this.focused));
  }
}
